module.exports = __webpack_public_path__ + "img/monitoring.e383cbf2.svg";